import { useState, useContext } from 'react';
import { JobsApplyContext, UserContext } from 'contexts';
import { UserContextType } from '../contexts/userContext';
import { JobsApplyContextType } from '../contexts/jobsApplyContext';

interface ReturnUseLogout {
    logout: () => void;
    isLogoutLoading: boolean;
}

export const useLogout = (resolveLogic: Function): ReturnUseLogout => {
  const [isLogoutLoading, setIsLoading] = useState(false);
  const { setLastSelectedJob } = useContext<UserContextType>(UserContext);
  const { setJobsData } = useContext<JobsApplyContextType>(JobsApplyContext);

  const logout = (): void => {
    localStorage.removeItem('auth');
    localStorage.removeItem('token');
    localStorage.removeItem('email');
    localStorage.removeItem('userId');
    localStorage.removeItem('airtableUserId');
    setJobsData(null);
    setLastSelectedJob(null);
    resolveLogic();
  };

  return {
    logout,
    isLogoutLoading,
  };
};
